import { Component, OnInit, OnDestroy, NgZone, ViewChild } from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {
  AuthorizationService,
  EventSubscriptionService,
  EquipmentService,
  ModelService,
  PoweredByService,
  MinesiteService,
  Company,
  Document,
  User,
  Equipment,
  Minesite,
  Model,
  PoweredBy,
} from "./../../../../shared/index";

@Component({
  selector: "equipment-details",
  templateUrl: "./equipment-details.html",
  standalone: false,
})
export class EquipmentDetailsComponent implements OnInit, OnDestroy {
  @ViewChild("equipmentDetails") modal: ModalDirective;
  public equipment: Equipment = new Equipment();
  public companies: Company[] = [];
  public users: User[] = [];
  public documents: Document[] = [];
  public model: Model = new Model();
  public minesite: Minesite = new Minesite();
  public poweredBy: PoweredBy = new PoweredBy();

  private subscriptions: Subscription[] = [];

  constructor(
    private _ngZone: NgZone,
    private _equipmentService: EquipmentService,
    private _poweredByService: PoweredByService,
    private _modelService: ModelService,
    private _minesiteService: MinesiteService
  ) {
    //this._eventService.configure(this)
    //    .Add(this._classificationService.classificationChange.subscribe((info: any) => this.onClassificationChange(info)))
    //    .Add(this._modelService.manipulateModel.subscribe((info: any) => this.onManipulateModel(info)))
    this.subscriptions.push(
      this._equipmentService.equipmentDocumentsChange.subscribe((info: any) =>
        this.onEquipmentDocuments(info)
      )
    );
    this.subscriptions.push(
      this._equipmentService.equipmentUsersChange.subscribe((info: any) =>
        this.onEquipmentUsers(info)
      )
    );
    this.subscriptions.push(
      this._equipmentService.equipmentCompaniesChange.subscribe((info: any) =>
        this.onEquipmentCompanies(info)
      )
    );
    this.subscriptions.push(
      this._equipmentService.showDetailsChange.subscribe((info: any) =>
        this.onShowDetails(info)
      )
    );
  }

  public close() {
    this.modal.hide();
  }

  private onEquipmentDocuments(documents: Document[]): void {
    this._ngZone.run(() => {
      this.documents = documents;
    });
  }
  private onEquipmentUsers(users: User[]): void {
    this._ngZone.run(() => {
      this.users = users;
    });
  }
  private onEquipmentCompanies(companies: Company[]): void {
    this._ngZone.run(() => {
      this.companies = companies;
    });
  }

  private onShowDetails(equipment: Equipment): void {
    this.poweredBy = this._poweredByService.poweredBys.GetByMap(
      0,
      equipment.PoweredById
    );
    this.model = this._modelService.models.GetByMap(0, equipment.ModelId);
    this.minesite = this._minesiteService.minesites.GetByMap(
      0,
      equipment.MinesiteId
    );

    let isStagedDetails = false;
    if (equipment.Id == 0) {
      equipment.Id = equipment.Equipment_ID;
      isStagedDetails = true;
    }
    this._equipmentService.getUsersForEquipment(equipment.Id, isStagedDetails);
    this._equipmentService.getDocumentsForEquipment(
      equipment.Id,
      isStagedDetails
    );
    this._equipmentService.getCompaniesForEquipment(
      equipment.Id,
      isStagedDetails
    );
    this.equipment = equipment;

    this.modal.show();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
